var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex justify-content-center",
      class: { "align-items-center": _vm.centerText }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-center",
          staticStyle: { width: "50%" }
        },
        [
          _vm.size
            ? _c("apexchart", {
                attrs: {
                  type: "donut",
                  height: _vm.size,
                  width: _vm.size,
                  options: _vm.formatOpts,
                  series: _vm.formatData
                }
              })
            : _vm._e(),
          !_vm.size
            ? _c("apexchart", {
                attrs: {
                  type: "donut",
                  options: _vm.formatOpts,
                  series: _vm.formatData
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "d-flex flex-column",
          class: { "justify-content-center": _vm.centerText }
        },
        [
          _c(
            "v-simple-table",
            {
              staticClass: "tabela-composition",
              staticStyle: { background: "transparent", width: "100%" },
              attrs: { dense: "" }
            },
            [
              [
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.lista, function(c) {
                      return [
                        c.percent > 0
                          ? _c("tr", { key: c.name, staticClass: "mb-1" }, [
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("v-sheet", {
                                      style: { "background-color": c.color },
                                      attrs: { height: "20", width: "5" }
                                    }),
                                    _c("p", { staticClass: "ml-1 mr-5 mb-0" }, [
                                      _vm._v(" " + _vm._s(c.name) + " ")
                                    ])
                                  ],
                                  1
                                )
                              ]),
                              _c("td", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-bold mb-0 mr-2 text-right"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.toPercent(c.percent)) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ])
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }